/**
 * Constantes globais do Doclenz Admin.
 */

export const APP_NAME = 'Doclenz Admin'

export const APP_VERSION = import.meta.env.VITE_REACT_APP_VERSION || '1.0.0'

/**
 * Vazio em produção de propósito: o nginx da própria imagem faz proxy de `/v1/` para o
 * doclenz-api, então as chamadas saem same-origin e não há CORS para resolver.
 * Em desenvolvimento, o vite.config faz o mesmo proxy.
 */
export const API_URL = import.meta.env.VITE_API || ''

export const TRANSLATION_NAME = 'app'

export const STORAGE_KEYS = {
  /** Chave de admin — o único segredo que autentica o console. */
  ADMIN_KEY: 'doclenz.admin-key',
  /** Chave de tenant usada só pelo playground, para chamar POST /v1/extract. */
  PLAYGROUND_KEY: 'doclenz.playground-key',
  USER: 'doclenz.current-user',
  COLOR_SCHEME: 'mantine-color-scheme',
} as const

/** Tenant sob o qual o playground extrai, para o consumo dele não se misturar ao de cliente. */
export const PLAYGROUND_TENANT = 'playground'

/** Extração síncrona de documento grande passa longe de 30 s. */
export const DEFAULT_REQUEST_TIMEOUT = 120000

export const DEFAULT_PAGE_SIZE = 20

/** Features que uma API key pode habilitar (ApiKeyRecord.features no backend). */
export const AVAILABLE_FEATURES = ['ocr', 'vision', 'audio', 'llm_enrichment'] as const
